import { atom } from 'jotai';

export const isShareDropdownOpenAtom = atom<{
  open: boolean;
  autoFocus: boolean;
}>({ open: false, autoFocus: false });
